<template>
  <ul
    :class="['navigation', { 'navigation--vertical': showInDrawer, 'navigation--single-item': hasSingleItem }]"
  >
    <template v-if="isAuthorized && isInAppRoute">
      <NavigationLink
        :route="PATH_DASHBOARD"
        :text="config.dashboard.text"
        @click.native="handleDrawerToggle"
        icon="dashboard-line"
        v-if="config.dashboard.visible"
      />
      <NavigationLink
        :route="PATH_INVOICES_OVERVIEW"
        :text="config.invoices.text"
        @click.native="handleDrawerToggle"
        icon="invoice-dollar"
        v-if="config.invoices.visible"
      />
      <NavigationLink
        :route="PATH_CONTACTS"
        :text="config.contacts.text"
        @click.native="handleDrawerToggle"
        icon="contacts-new"
        v-if="config.contacts.visible"
      />
      <NavigationLink
        :route="PATH_REPORTS"
        :text="config.reports.text"
        @click.native="handleDrawerToggle"
        icon="reports-new"
        v-if="config.reports.visible"
      />
      <NavigationLink
        :route="PATH_EXPENSES"
        :text="config.expenses.text"
        @click.native="handleDrawerToggle"
        icon="wallet-new"
        v-if="config.expenses.visible"
      />
      <li
        v-if="!showInDrawer && config.account.visible"
        class="navigation__item"
      >
        <LoginButton />
      </li>
      <li
        v-if="showInDrawer && config.account.visible"
        class="navigation__item navigation__item--without-delimiter"
      >
        <Button
          class="navigation__button navigation__button--with-arrow"
          icon="icon icon-user-line"
          type="text"
          is-navbar-button
          @click="handleUserMenuClick"
        >
          <div class="navigation__button-wrapper">
            <span>{{ $t('header.myAccount') }}</span>
            <i
              class="icon icon-chevron-right"
            />
          </div>
        </Button>
      </li>
    </template>

    <template v-else-if="!isAuthorized">
      <NavigationLink
        :route="PATH_INVOICES_OVERVIEW"
        :text="config.invoices.text"
        :class="[{'pt-8': showInDrawer}]"
        @click.native="handleDrawerToggle"
        icon="invoice-dollar"
        v-if="config.invoices.visible"
      />
      <NavigationLink
        :route="PATH_REPORTS"
        :text="config.reports.text"
        @click.native="handleDrawerToggle"
        icon="reports-new"
        v-if="config.reports.visible"
      />
      <NavigationLink
        :route="PATH_EXPENSES"
        :text="config.expenses.text"
        @click.native="handleDrawerToggle"
        icon="wallet-new"
        v-if="config.expenses.visible"
      />
    </template>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  PATH_INVOICES_OVERVIEW, PATH_REPORTS, PATH_EXPENSES, PATH_DASHBOARD, PATH_CONTACTS,
} from '~/router';
import { isInAppRoute } from '~/lib/routerHelper';
import { navbarConfig } from '~/config/navbarConfig';
import LoginButton from '../header/LoginButton.vue';
import NavigationLink from './NavigationLink.vue';

export default {
  components: {
    LoginButton,
    NavigationLink,
  },
  props: {
    showInDrawer: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    PATH_EXPENSES,
    PATH_INVOICES_OVERVIEW,
    PATH_REPORTS,
    PATH_DASHBOARD,
    PATH_CONTACTS,
    navbarConfig,
  }),
  computed: {
    ...mapGetters('auth', [
      'isAuthorized',
    ]),
    isInAppRoute,
    config() {
      return this.$i18n.locale === 'en' ? navbarConfig.usa : navbarConfig.default;
    },
    hasSingleItem() {
      if (!this.isAuthorized) {
        const visibleCountItems = [
          this.config.invoices.visible,
          this.config.reports.visible,
          this.config.expenses.visible,
        ].filter(Boolean).length;
        return visibleCountItems === 1;
      }
      return false;
    },
  },
  methods: {
    handleDrawerToggle() {
      this.$emit('handle-drawer-toggle');
    },
    handleUserMenuClick() {
      this.$emit('handle-user-menu-click');
    },
  },
};
</script>

<style lang="scss" scoped>
.navigation {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0;
  padding-left: 0;
  list-style: none;
}

.navigation--single-item {
  margin-left: auto;
}

.navigation__button-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 2.1rem);
}

.navigation__button--with-arrow {
  padding-top: 9px;
  padding-bottom: 9px;
}
</style>

<style lang="scss">
.navigation--vertical {
  .navigation__item {
    width: 100%;
    padding: 8px 0;
    border-bottom: 1px solid $--border-color-base;

    &:first-of-type {
      padding-top: 0;
    }

    &--without-delimiter {
      border-bottom: none;
    }
  }
}
</style>
